import LazyLoadOnScroll from "@Components/LazyLoadOnScroll";
import styles from "./Tag.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

type TagProps = {
  name: string;
  icon?: string;
};

const Tag = ({ name, icon = "" }: TagProps) => {
  const { t } = useTranslationHook();
  return (
    <div className={styles.tagContainer}>
      <LazyLoadOnScroll
        customRootMargin="0px"
        fallback={
          <section
            style={{
              height: "16px",
              width: "16px",
            }}
          />
        }
      >
        <span className={styles.icon}>{icon}</span>
      </LazyLoadOnScroll>
      <div data-testid="property-room-type-tenancy-amenities" className={styles.tagName}>
        {t(name)}
      </div>
    </div>
  );
};
export default wrapperHOC(Tag, {
  componentName: "Tag-RoomTypeCard-RoomTypeSection-PropertyPage",
  showForChina: true,
});
